<template>
  <div class="register">
    <h3 class="left-border">
      {{
        $t('register-page.title', {
          split: '/'
        })
      }}
    </h3>

    <div class="steps">
      <div class="item" :class="step === STEP_ONE ? 'active' : ''">
        <span class="mr-3">1</span>
        <h3 v-html="$t('register-page.step.one', { split: '<br />' })"></h3>
      </div>
      <v-icon size="50">{{ arrowIcon }}</v-icon>
      <div class="item" :class="step === STEP_TWO ? 'active' : ''">
        <span class="mr-3">2</span>
        <h3 v-html="$t('register-page.step.two', { split: '<br />' })"></h3>
      </div>
      <v-icon size="50">{{ arrowIcon }}</v-icon>
      <div class="item" :class="step === STEP_THREE ? 'active' : ''">
        <span class="mr-3">3</span>
        <h3 v-html="$t('register-page.step.three', { split: '<br />' })"></h3>
      </div>

      <v-icon size="50">{{ arrowIcon }}</v-icon>
      <div class="item" :class="step === STEP_FOUR ? 'active' : ''">
        <span class="mr-3">4</span>
        <h3 v-html="$t('register-page.step.four', { split: '<br />' })"></h3>
      </div>
    </div>

    <step-one
      v-if="step === STEP_ONE"
      :urlRegisterCode="urlRegisterCode"
    ></step-one>
    <step-two
      v-if="step === STEP_TWO"
      :urlRegisterCode="urlRegisterCode"
    ></step-two>
    <step-three
      v-if="step === STEP_THREE"
      :urlRegisterCode="urlRegisterCode"
    ></step-three>
    <register-success
      v-if="step === STEP_FOUR"
      :urlRegisterCode="urlRegisterCode"
    ></register-success>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiMenuRight, mdiCalendar } from '@mdi/js';
import { STEP_ONE, STEP_TWO, STEP_THREE, STEP_FOUR } from '@/common/constants';

import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import RegisterSuccess from './RegisterSuccess';

export default {
  name: 'Register',
  components: {
    'step-one': StepOne,
    'step-two': StepTwo,
    'step-three': StepThree,
    'register-success': RegisterSuccess
  },

  data() {
    return {
      arrowIcon: mdiMenuRight,
      calendarIcon: mdiCalendar,
      modal: false,
      date: new Date().toISOString().substr(0, 10),
      step: 1,
      urlRegisterCode: null
    };
  },

  watch: {
    $route: {
      handler: function (route) {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (route !== null) {
          const { event_day_register_url_code, step } = route.query;

          if (typeof event_day_register_url_code !== 'undefined') {
            this.urlRegisterCode = event_day_register_url_code;
            if (this.m_event) {
              const { event_day_register_url_code } = this.m_event;

              if (
                this.urlRegisterCode !== null &&
                event_day_register_url_code !== this.urlRegisterCode
              ) {
                this.$router.push({ name: 'login-applicant' }, () => {});
              } else {
                this.$store.dispatch('setRegistrationPeriodStatus', true);
                this.urlCode = event_day_register_url_code;
                this.query = {
                  event_day_register_url_code: this.urlCode
                };
              }
            }
          }

          if (typeof step === 'undefined') {
            return (this.step = STEP_ONE);
          } else {
            return (this.step = parseInt(step));
          }

          if (typeof event_day_register_url_code === 'undefined') {
            return (this.urlRegisterCode = event_day_register_url_code);
          } else {
            return (this.urlRegisterCode = event_day_register_url_code);
          }
        }
      },
      immediate: true
    },
    registerStatus: function (val) {
      return val;
    },

    registrationPeriodStatus: function (val) {
      if (val === false) {
        this.$router.push('/');
      }
    },

    urlRegisterCode: function (val) {}
  },

  methods: {
    checkRedirectStep() {
      const registerData =
        localStorage.getItem('registerData') !== null
          ? JSON.parse(localStorage.getItem('registerData'))
          : null;
      if (registerData !== null) {
        const { stepOne, stepTwo } = registerData;

        if (typeof stepOne.name === 'undefined') {
          this.$router.replace({
            name: 'register-applicant',
            query: {
              event_day_register_url_code: this.urlRegisterCode,
              step: 1
            }
          });
        } else if (typeof stepOne.name !== 'undefined' && stepTwo === null) {
          this.$router.replace({
            name: 'register-applicant',
            query: {
              event_day_register_url_code: this.urlRegisterCode,
              step: 1
            }
          });
        } else if (
          typeof stepOne.name !== 'undefined' &&
          stepTwo !== null &&
          typeof stepTwo.study_status === 'undefined'
        ) {
          this.$router.replace({
            name: 'register-applicant',
            query: {
              event_day_register_url_code: this.urlRegisterCode,
              step: 2
            }
          });
        } else if (
          (typeof stepOne.name !== 'undefined' &&
            typeof stepTwo.study_status !== 'undefined') === true
        ) {
          this.$router.replace({
            name: 'register-applicant',
            query: {
              event_day_register_url_code: this.urlRegisterCode,
              step: 3
            }
          });
        } else {
          this.$router.replace({
            name: 'register-applicant',
            query: {
              event_day_register_url_code: this.urlRegisterCode,
              step: 1
            }
          });
        }
      } else {
        this.$router.push({
          name: 'register-applicant',
          query: { event_day_register_url_code: this.urlRegisterCode, step: 1 }
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      registerStatus: 'getRegisterStatus'
    })
  },
  created() {
    this.STEP_ONE = STEP_ONE;
    this.STEP_TWO = STEP_TWO;
    this.STEP_THREE = STEP_THREE;
    this.STEP_FOUR = STEP_FOUR;

    if (this.$route.query !== null) {
      const { event_day_register_url_code } = this.$route.query;

      if (typeof event_day_register_url_code !== 'undefined') {
        this.urlRegisterCode = event_day_register_url_code;
        if (this.m_event) {
          const { event_day_register_url_code } = this.m_event;

          if (
            this.urlRegisterCode !== null &&
            event_day_register_url_code !== this.urlRegisterCode
          ) {
            this.$router.push(this.pathDefault, () => {});
          } else {
            this.$store.dispatch('setRegistrationPeriodStatus', true);
            this.urlRegisterCode = event_day_register_url_code;
            this.query = {
              event_day_register_url_code: this.urlRegisterCode
            };
          }
        }
      }
    }

    this.checkRedirectStep();
  },

  mounted() {
    if (!this.registrationPeriodStatus) {
      this.$router.push({ name: 'login-applicant' }, () => {});
    }
  },

  destroyed() {
    if (this.urlRegisterCode !== null) {
      this.$store.dispatch('setRegistrationPeriodStatus', false);
    }
  }
};
</script>

<style lang="scss">
@import './register.scss';
@media only screen and (max-width: 960px) {
  .register {
    .left-border {
      margin-top: 80px !important;
    }
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .register .steps {
    align-items: center !important;
  }
}
</style>
